<div class="call-status-badge">
  <span
    class="status-dot"
    [ngClass]="{
      'available': (callState$ | async) === 'idle',
      'incoming': (callState$ | async) === 'ringing-in',
      'in-call': (callState$ | async) === 'connected'
    }"
    [title]="(callState$ | async) === 'idle' ? 'Available' : (callState$ | async) === 'ringing-in' ? 'Incoming call' : 'In call'">
  </span>
</div>
